export const feats = [
    "Silny",
    "Szybki",
    "Zwinny",
    "Wytrzymały",
    "Inteligentny",
    "Sprytny",
    "Charyzmatyczny",
    "Żywotny",
    "Urok osobisty",



    "Szybki refleks",
    "Zwinne dłonie",
    "Wyczulone zmysły",
    "Slina wola",
    
    "Gadanina",
    "Plotkarz",
    "Dyplomata",
    "Uparty",
    "Ładny",

    "Masywny",
    "Odporny",
    "Obrońca",
    "Nieustraszony",
    "Taktyk",
    "Empatyczny",
    "Lider",
    "Mistrz kamuflażu",
    "Jak kameleon",
    "Przekonujący",
    "Oszust",
    "Wędrowiec",
    "Negocjator",

    
    "Sztuka przetrwania",
    "Złota rączka",
    "Dobre zdrowie",
    "Znawca natury",
    "Szybki uczeń",
    "Poliglota",
    "Analityczny umysł",
    "Dobra pamięć",
    "Alchemia",
    "Hirurg",
    "Cwany",
    "Czarujący",
    "Sokoli wzrok",
    "Bijatyka",
    "Dusza towarzystwa",
    "Znajomość półświatka",
    "Spokojny",
    "Dobre serce",
    "Zwinny"
    

    
];